<template>
  <div>
    <q-card class="marginTag">
      <q-card-section>
        <div class="titleCard">Datos indicador</div>
        <div v-if="this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length<=0" class="noData col-12">NO HAY DATOS DISPONIBLES</div>
        <div v-else class="row">
          <div class="col-12 row grafic">
            <div class="grafico col-12">
              <GraficaMunicipioIndicadorAUE :dataIndicador="indicador" :datosObjetivo="datosObjetivo"/>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <DialogCreate
      v-model="showDialog"
      labelSuccess="Cerrar"
      :showBottonCancel="false"
      @save="aceptar()"
    >
      <template slot="body">
        <div class="noDataDialog title-option text-center">
          {{msgDialog}}
        </div>
      </template>
    </DialogCreate>
    </div>
</template>
<script>
import GraficaMunicipioIndicadorAUE from './GraficaMunicipioIndicadorAUE.vue';
import moment from 'moment';
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';

export default {
  components: {
    GraficaMunicipioIndicadorAUE,
    DialogCreate
  },
  props: {
    dataIndicador: Object
  },
  watch: {
    dataIndicador () {
      this.indicador = this.dataIndicador;
    }
  },
  created () {
    this.indicador = this.dataIndicador;
    this.unidadMedidaIndicador = this.dataIndicador.unidadMedida;

    if (this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length > 0) {
      let dateInicioSimple = this.dataIndicador.fechaInicio.split('T');
      let dateFinSimple = this.dataIndicador.fechaFin.split('T');
      this.fechaInicioMunicipal = moment(dateInicioSimple[0]).format('YYYY/MM/DD');
      this.fechaFinMunicipal = moment(dateFinSimple[0]).format('YYYY/MM/DD');
    }
    this.datosObjetivo = { datoObjetivo: this.dataIndicador.datosPartidaYObjetivo.datoObjetivo, fechaDatoObjetivo: this.dataIndicador.datosPartidaYObjetivo.fechaDatoObjetivo, unidadMedida: this.dataIndicador.datosPartidaYObjetivo.unidadMedida };
  },
  data () {
    return {
      indicador: {},
      fechaIniFiltered: null,
      fechaFinFiltered: null,
      fechaInicioMunicipal: null,
      fechaFinMunicipal: null,
      showDialog: false,
      msgDialog: '',
      unidadMedidaIndicador: ''
    };
  },
  methods: {
    aceptar () {
      this.showDialog = false;
    }
  }
};
</script>
<style lang="scss" scoped>

.marginTag{
  margin-top: 25px;
  height: 570px;

  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;

  .titleCard {
    margin: 0 0px 10px 4px;
    font-size: 20px;
    font-family: DINPro;
    font-weight: bold;
    letter-spacing: 0.29px;
    color: #474848;
  }
  .grafic{
    display: flex;
  }
  .text-center{
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .noData{
    height: 500px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -1.13px;
    color: $seafoam-blue-hover !important;
    align-items: center;
    display: flex;
    justify-content: center;
  }
}
.noDataDialog{
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -1.13px;
  color: $seafoam-blue-hover;
}

@media (max-width: 640px) {
  ::v-deep {
    .marginTag{
      height: 420px;
    }
  }
}

</style>
